import { ActivityTypes } from './Activities';
import { getDateInLocalTimeZone, isValidDateOrDateString } from './DateTime';

export const getSessionDuration = (instancesNumber: number, type: ActivityTypes) => {
  if (instancesNumber === undefined) {
    return '-';
  }
  let duration = instancesNumber.toString();
  if (type === ActivityTypes.Camp) {
    duration = duration.concat(' day');
  } else {
    duration = duration.concat(' lesson');
  }

  if (instancesNumber !== 1) {
    duration = duration.concat('s');
  }

  return duration;
};

export const displaySessionDuration = (numberOfInstances = 0, type) => {
  if (numberOfInstances > 1) return getSessionDuration(numberOfInstances, type);
  return '';
};

export const displaySessionStartDate = (numberOfInstances = 0, startDateTime: Date | string | undefined) => {
  if (!startDateTime || !isValidDateOrDateString(startDateTime)) return '-';
  if (numberOfInstances > 1) return 'Starts ' + getDateInLocalTimeZone(startDateTime);
  return getDateInLocalTimeZone(startDateTime);
};
